import { render, staticRenderFns } from "./MatrixVariations.vue?vue&type=template&id=925bff8a&"
import script from "./MatrixVariations.vue?vue&type=script&lang=js&"
export * from "./MatrixVariations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\matrix_varianten\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('925bff8a')) {
      api.createRecord('925bff8a', component.options)
    } else {
      api.reload('925bff8a', component.options)
    }
    module.hot.accept("./MatrixVariations.vue?vue&type=template&id=925bff8a&", function () {
      api.rerender('925bff8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/MatrixVariations.vue"
export default component.exports